import { render, staticRenderFns } from "./DetailHasilUjianTPA.vue?vue&type=template&id=59c6dd68&scoped=true"
import script from "./DetailHasilUjianTPA.vue?vue&type=script&lang=js"
export * from "./DetailHasilUjianTPA.vue?vue&type=script&lang=js"
import style0 from "./DetailHasilUjianTPA.vue?vue&type=style&index=0&id=59c6dd68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c6dd68",
  null
  
)

export default component.exports